<div class='row status-page__header ps-0'>
  <div class='col-lg-3 col-md-3 col-10 pe-3'>
    <app-facility-select id='facility-selector'></app-facility-select>
  </div>
  <div class='col-lg-9 col-md-9 col-2 header-global-search'>
    <app-global-search id='global-search'></app-global-search>
    <div *ngIf='infoActive' [ngClass]='{active : active}' class='header-info'>
      <button (click)='handleClick()' [nbPopoverContext]="{text: 'Example context'}" [nbPopover]='infoComponent'
              class='alarm-bell-icon' ghost icon='info'
              nbButton nbPopoverPlacement='bottom' nbPopoverTrigger='click'>
        <nb-icon
          class='alarm-bell-icon' icon='info' nbPrefix
          pack='eva'
          status='control'></nb-icon>
      </button>
    </div>
    <div *ngIf='notificationsActive' class='header-notifications'>
      <button [nbPopoverContext]="{text: 'Example context'}" [nbPopover]='notificationsComponent' ghost nbButton
              nbButton
              nbPopoverPlacement='bottom' nbPopoverTrigger='click'>
        <nb-icon class='alarm-bell-icon' icon='bell' nbPrefix pack='eva' status='control'></nb-icon>
      </button>
    </div>
  </div>
</div>
